import StockAnalystApp from "./stock-analyst/StockAnalystApp";
import RealEstateBusinessApp from "./real-estate/RealEstateBusinessApp";

function App() {
  const pathname = typeof window === "undefined" ? "" : window.location.pathname;
  if (pathname.startsWith("/real-estate")) return <RealEstateBusinessApp />;
  return <StockAnalystApp />;
}

export default App;
